import React from 'react';

import { AdminEntitlementsSearchActions } from '../../../../../data/global/actions/admin/EntitlementsActions';
import { useDispatcher } from '../../../../../data/global/hooks';
import { useBlockId } from '../../../../../components/blocks/BlockState';

export const EntitlementsActionCell: React.FunctionComponent<{ entitlementId: number }> = ({ entitlementId }) => {
  const { dispatch } = useDispatcher();
  const blockId = useBlockId();

  return (
    <button className="btn" onClick={() => dispatch(AdminEntitlementsSearchActions.setSelectedEntitlementId({ entitlementId, blockId }))}>
      View
    </button>
  );
};
